import { render } from "./ProductFilter.vue?vue&type=template&id=3de90a9e&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"

import "./ProductFilter.vue?vue&type=style&index=0&id=3de90a9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de90a9e"]])

export default __exports__